import React from "react";
import { useNavigate } from "react-router-dom";
import "./Navodila.css";

const SKLOPI = [
    {
        title: "Nov primer",
        text: "Začnite z vnosom št. spisa izvršitelja ali opr. št. sodišča. Nato pridobite podatke upnika in dolžnika, izpolnite manjkajoča polja, dodajte stroškovnik ter po potrebi izvozite PDF ali Excel.",
    },
    {
        title: "Podatki o upniku",
        text: "Vpišite davčno ali matično številko upnika. Portal najprej preveri shranjene podatke, nato lahko pridobi podatke iz AJPES. Dopolnite TRR, banko, kontakt, status in druge podatke.",
    },
    {
        title: "Podatki o dolžniku",
        text: "Vpišite davčno ali matično številko dolžnika. Dodate lahko TRR-je, banke, dolg, glavnico, stroške, obresti in podatke o predhodnih rubežih.",
    },
    {
        title: "Pobotnica",
        text: "Pobotnica je namenjena pripravi podatkov za zadevo. Podatki izvršitelja se naložijo za prijavljenega uporabnika, ostala polja pa dopolnite glede na konkretno zadevo.",
    },
    {
        title: "Stroškovnik",
        text: "Vnesite vrednost točke, postavke, tarife in zneske. Dodate lahko kilometrino, obračun zakonskih zamudnih obresti ter dokument natisnete ali izvozite v PDF.",
    },
    {
        title: "Rubeži",
        text: "Za vsak rubež vnesite datum, uro, opis zarubljenega in izvršitelja. Podatke lahko shranite za nadaljnjo uporabo.",
    },
];

export default function Navodila() {
    const navigate = useNavigate();

    return (
        <main className="navodila-page">
            <section className="navodila-card">
                <header className="navodila-header">
                    <div className="navodila-header__text">
                        <h1 className="navodila-title">Navodila za uporabo portala</h1>
                        <p className="navodila-subtitle">
                            Kratek pregled glavnih strani in pravilnega vnosa podatkov.
                        </p>
                    </div>

                    <button
                        type="button"
                        className="btn-nazaj"
                        onClick={() => navigate("/profil", { replace: true })}
                        aria-label="Nazaj na profil"
                        title="Nazaj"
                    >
                        <span className="btn-nazaj__icon" aria-hidden="true">
                            ←
                        </span>
                    </button>
                </header>

                <section className="navodila-intro">
                    <h2>Osnovni potek dela</h2>
                    <p>
                        Najhitrejši način dela je, da najprej odprete stran <strong>Nov primer</strong>,
                        vpišete osnovne podatke zadeve, pridobite podatke upnika in dolžnika ter nato
                        uredite stroškovnik, rubeže ali ostale dokumente.
                    </p>
                </section>

                <section className="navodila-grid" aria-label="Navodila po straneh">
                    {SKLOPI.map((sklop) => (
                        <article key={sklop.title} className="navodila-item">
                            <h3>{sklop.title}</h3>
                            <p>{sklop.text}</p>
                        </article>
                    ))}
                </section>

                <section className="navodila-tips">
                    <h2>Koristni nasveti</h2>

                    <ul>
                        <li>Davčna številka ima 8 številk, matična številka pa 10 številk.</li>
                        <li>Pri izvozu PDF ali tiskanju se uporabljajo svetle, pregledne barve.</li>
                        <li>Podatki so vezani na prijavljenega uporabnika.</li>
                        <li>Če se podatki iz AJPES ne naložijo, preverite številko in internetno povezavo.</li>
                    </ul>
                </section>
            </section>
        </main>
    );
}